module.exports = __webpack_public_path__ + "static/media/panche-baja.3e7e8bde.png";